import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';

export interface IErrorBoundaryProps {
  fallback?: React.ReactElement;
  children: React.ReactNode;
}

function DefaultFallback() {
  return <div>Something went wrong</div>;
}

export function ErrorBoundary({ children, fallback, ...props }: IErrorBoundaryProps) {
  return (
    <SentryErrorBoundary
      fallback={fallback ?? <DefaultFallback />}
      {...props}
      onError={(error, componentStack) => {
        console.error('React error:', error);
        console.error('Component stack:', componentStack);
      }}
    >
      {children}
    </SentryErrorBoundary>
  );
}
